import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VRow, {
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VRow, {
    staticClass: "px-4"
  }, [_c(VCol, {
    attrs: {
      "xs": "12",
      "sm": "12",
      "md": "8"
    }
  }, [_c(VCombobox, {
    attrs: {
      "data-cy": "input_address",
      "disabled": _vm.disabled,
      "items": _vm.entries,
      "search-input": _vm.search,
      "label": _vm.$i18n_t('Common.addressWithSearch'),
      "loading": _vm.isLoading,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "item-text": "formatted_address",
      "hide-details": "",
      "no-filter": "",
      "clearable": ""
    },
    on: {
      "update:searchInput": function ($event) {
        _vm.search = $event;
      },
      "update:search-input": function ($event) {
        _vm.search = $event;
      },
      "change": function ($event) {
        return _vm.handleAddressChange();
      },
      "click:clear": function ($event) {
        return _vm.clearAddress();
      }
    },
    model: {
      value: _vm.address,
      callback: function ($$v) {
        _vm.address = $$v;
      },
      expression: "address"
    }
  })], 1), _c(VCol, {
    attrs: {
      "xs": "12",
      "sm": "6",
      "md": "2"
    }
  }, [_c(VTextField, {
    attrs: {
      "data-cy": "input_latitude",
      "disabled": _vm.disabled,
      "label": _vm.$i18n_t('Common.lat'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "rules": _vm.ruleValidateCoordinates(_vm.coordinates[1]),
      "clearable": ""
    },
    on: {
      "input": function ($event) {
        return _vm.formatLonLat(_vm.coordinates, 1);
      },
      "change": _vm.handleCoordinateChange,
      "click:clear": function ($event) {
        return _vm.clearAddress();
      }
    },
    model: {
      value: _vm.coordinates[1],
      callback: function ($$v) {
        _vm.$set(_vm.coordinates, 1, $$v);
      },
      expression: "coordinates[1]"
    }
  })], 1), _c(VCol, {
    attrs: {
      "xs": "12",
      "sm": "6",
      "md": "2"
    }
  }, [_c(VTextField, {
    attrs: {
      "data-cy": "input_longitude",
      "disabled": _vm.disabled,
      "label": _vm.$i18n_t('Common.lon'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "rules": _vm.ruleValidateCoordinates(_vm.coordinates[0]),
      "clearable": ""
    },
    on: {
      "input": function ($event) {
        return _vm.formatLonLat(_vm.coordinates, 0);
      },
      "change": _vm.handleCoordinateChange,
      "click:clear": function ($event) {
        return _vm.clearAddress();
      }
    },
    model: {
      value: _vm.coordinates[0],
      callback: function ($$v) {
        _vm.$set(_vm.coordinates, 0, $$v);
      },
      expression: "coordinates[0]"
    }
  })], 1)], 1), _vm.pickedManualCoordinates ? [_c(VCol, {
    attrs: {
      "cols": "12",
      "sm": "8",
      "md": "9"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$i18n_t('Common.addressDecoupledFromCoordText')) + "\n    ")]), _c(VCol, {
    attrs: {
      "cols": "12",
      "sm": "4",
      "md": "3"
    }
  }, [_c(VBtn, {
    class: `v-btn-x mx-1 v-btn--rounded bg-rounded-button-${_vm.color}`,
    attrs: {
      "title": _vm.$i18n_t('Common.addressReconnectButton'),
      "color": _vm.color,
      "rounded": "",
      "text": ""
    },
    on: {
      "click": _vm.handleReconnectCoordinates
    }
  }, [_c(VIcon, {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("fal fa-plug")]), _vm._v("\n          " + _vm._s(_vm.$i18n_t('Common.addressReconnectButton')) + "\n      ")], 1)], 1)] : _vm._e(), _vm.mapView && _vm.hasValidCoordinate ? _c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c(VDialog, {
    attrs: {
      "dark": _vm.UiTheme,
      "max-width": "1200px"
    },
    model: {
      value: _vm.fullScreenMap,
      callback: function ($$v) {
        _vm.fullScreenMap = $$v;
      },
      expression: "fullScreenMap"
    }
  }, [_c('core-maps', {
    attrs: {
      "markerDraggable": _vm.markerDraggable && !_vm.disabled,
      "geoCoordinates": _vm.coordinates,
      "allowScrollZoom": "",
      "fullScreen": ""
    },
    on: {
      "close-expanded": function ($event) {
        _vm.fullScreenMap = false;
      }
    }
  })], 1), _c('core-maps', {
    attrs: {
      "markerDraggable": _vm.markerDraggable && !_vm.disabled,
      "geoCoordinates": _vm.coordinates
    },
    on: {
      "markerUpdated": _vm.handleMarkerUpdate,
      "expand": function ($event) {
        _vm.fullScreenMap = true;
      }
    }
  })], 1) : _vm._e()], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };